// extracted by mini-css-extract-plugin
export default {"skeletonLoader":"SkeletonField_skeletonLoader__8bRIb","loading":"SkeletonField_loading__1abpv"};